module.exports = __webpack_public_path__ + "static/badmus-72350b5ba0fbf5dcadea0269b91a0563.png";